import SMConst from 'lib/SMConst';

class SMPlanHelper {

  static hasHourlyPrice(plan){
    if (!plan.has_session_price && plan.has_hourly_price ||
        plan.has_session_price && plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour) {
      return true;
    } else {
      return false;
    }
  }

  static hasDailyPrice(plan){
    if (!plan.has_session_price && plan.has_daily_price ||
        plan.has_session_price && plan.min_required_session_hour_unit == SMConst.RequiredUnit.Day) {
      return true;
    } else {
      return false;
    }
  }

  static hasStayPrice(plan){
    if (plan.has_stay_price) {
      return true;
    } else {
      return false;
    }
  }

  static regularDailyPriceText(plan){
    if (plan.has_session_price) {
      return plan.session_price_text+'/'+plan.session_price_unit_text;
    } else {
      return plan.daily_price_text+'/'+plan.daily_price_unit_text;
    }
  }

  static regularHourlyPriceText(plan){
    if (plan.has_session_price) {
      return plan.session_price_text+'/'+plan.session_price_unit_text;
    } else {
      return plan.hourly_price_text+'/'+plan.hourly_price_unit_text;
    }
  }

  static regularStayPriceText(plan){
    return plan.stay_price_text+'/'+plan.stay_price_unit_text;
  }

  static shoudRenderMinRequiredDate(plan){
    return (plan.has_min_required_hour &&
            plan.min_required_hour > 1 &&
            plan.min_required_hour_unit == 1);
  }

  static shouldRenderMinRequiredTime(plan){
    return (plan.has_min_required_hour &&
            plan.min_required_hour > 1 &&
            plan.min_required_hour_unit == 0);
  }

  static shouldRenderRequiredFood(plan){
    return (plan.has_min_required_food_price || plan.is_required_food);
  }

  static isRoom(plan){
    return plan.hasOwnProperty('plan_name');
  }

  static isRequireOptionFood(plan) {
    return (plan.is_required_food || plan.has_min_required_food_price);
  }

}
export default SMPlanHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMPlanHelper.js